import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Phone, Mail, Globe } from "lucide-react";

function Field({ label, value }) {
  return (
    <div>
      <div className="text-[11px] uppercase tracking-widest text-slate-500 font-semibold">{label}</div>
      <div className="text-sm text-slate-800 mt-0.5">{value ?? "—"}</div>
    </div>
  );
}

export default function SupplierDetail() {
  const { id } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/suppliers/${id}`).then((r)=>setD(r.data)); }, [id]);
  if (!d) return <div className="text-slate-500">Loading…</div>;
  const s = d.supplier;
  return (
    <div className="space-y-4">
      <Link to="/suppliers" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-slate-800"><ArrowLeft className="w-4 h-4"/>Back to suppliers</Link>
      <div className="flex items-start justify-between">
        <div>
          <div className="text-xs uppercase tracking-widest text-slate-500">{s.service_area||"Supplier"}</div>
          <h1 className="font-heading text-3xl font-bold text-slate-900">{s.name}</h1>
        </div>
        <div className="flex gap-2">
          {s.phone && <Button size="sm" variant="outline" asChild><a href={`tel:${s.phone}`}><Phone className="w-4 h-4 mr-1"/>Call</a></Button>}
          {s.email && <Button size="sm" variant="outline" asChild><a href={`mailto:${s.email}`}><Mail className="w-4 h-4 mr-1"/>Email</a></Button>}
          {s.website && <Button size="sm" variant="outline" asChild><a href={s.website} target="_blank" rel="noreferrer"><Globe className="w-4 h-4 mr-1"/>Website</a></Button>}
        </div>
      </div>

      <Card className="border-slate-200"><CardContent className="p-5 grid grid-cols-2 md:grid-cols-3 gap-4">
        <Field label="Phone" value={s.phone}/>
        <Field label="Email" value={s.email}/>
        <Field label="Account / meter / ID" value={s.account_id}/>
        <Field label="ABN" value={s.abn}/>
        <Field label="Licence #" value={s.licence_number}/>
        <Field label="Licence expiry" value={s.licence_expiry}/>
        <Field label="Insurance expiry" value={s.insurance_expiry}/>
        <Field label="Frequency / trigger" value={s.frequency_trigger}/>
        <div className="col-span-full"><Field label="Notes" value={s.notes}/></div>
      </CardContent></Card>

      <Card className="border-slate-200"><CardContent className="p-4">
        <h3 className="font-heading text-lg font-semibold mb-2">Work orders</h3>
        {d.work_orders.length===0 ? <div className="text-sm text-slate-500">None yet.</div> :
          <ul className="divide-y divide-slate-100">
            {d.work_orders.map((w)=>(
              <li key={w.id} className="py-2 flex items-center justify-between">
                <div><div className="font-mono text-xs">{w.wo_number}</div><div className="text-sm">{w.description}</div></div>
                <Badge>{w.status}</Badge>
              </li>
            ))}
          </ul>
        }
      </CardContent></Card>
    </div>
  );
}
